package com.jingfangpai.api.clients

import com.jingfangpai.common.data.response.ApiResponse
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromString
import com.jingfangpai.common.coroutines.applicationDispatcher
import kotlinx.coroutines.launch
import io.ktor.http.*
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import com.jingfangpai.common.json.json
import kotlin.js.JsName
import io.ktor.content.TextContent
import io.ktor.client.call.body
import com.jingfangpai.api.base.BaseServiceClient
import kotlin.String
import com.jingfangpai.common.orm.mapping.enums.UserSex
import com.jingfangpai.common.data.type.Date

object UserApiClient :BaseServiceClient() {

	@JsName("login")
	fun login(account:kotlin.String,password:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.user.model.UserAuthData>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"account" to "${account?:""}",
			"password" to "${password?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.user.model.UserAuthData> = httpClient.post {
				    url("/api/user/login?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("register")
	fun register(userName:kotlin.String,sex:com.jingfangpai.common.orm.mapping.enums.UserSex,birthday:com.jingfangpai.common.data.type.Date?,mobilePhone:kotlin.String,account:kotlin.String,password:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.user.model.UserAuthData>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"userName" to "${userName?:""}",
			"sex" to "${sex?:""}",
			"birthday" to "${birthday?:""}",
			"mobilePhone" to "${mobilePhone?:""}",
			"account" to "${account?:""}",
			"password" to "${password?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.user.model.UserAuthData> = httpClient.post {
				    url("/api/user/register?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}

}
